import { toast } from 'react-toastify';
import { testDataForSheets } from '../config/index.js';
import api from './api';

/* Sample CSV download*/
export const sampleCSVdownload = () => {
	try {
		let sheetData = Object.values(testDataForSheets).join(',');

		let tableHead;
		tableHead =
			'Group Name, Group ID, User ID, Username, First Name, Last Name, Request Date, Joined Facebook On, No of Mutual Friends, No of Total Friends, No of Friends In Group, No of Common Groups, No of Other Groups, No of Total Groups, Extra Information, Gender, Country, Tiers, Date Added, Status, Q1, A1, Q2, A2, Q3, A3\n';

		let csvContent = 'data:text/csv;charset=utf-8,' + tableHead + sheetData;
		let encodedUri = encodeURI(csvContent);
		let link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', `Sample Data-GM-${new Date().getTime()}.csv`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		toast.success('Sample CSV has successfully downloaded');
	} catch (error) {
		toast.errpr('Something went wrong ! Please try again');
	}
};

/* Send test data to webhook*/
export const sendWebhookTestData = async (key, url) => {
	try {
		let testObj = {};
		testObj[key] = testDataForSheets;

		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		};
		const { data } = await api.post(
			'/api/helper/send-test-data',
			{ key, url },
			config
		);

		return data.success
			? toast.success('Test data has sent successfully')
			: toast.error(
				`We couldn't send the test data to this webhook. Please try again`
			);
	} catch (error) {
		toast.error('Something went wrong with your webhook');
	}
};

/** Get spreadsheet ID from spreadsheet url */
const getSpreadSheetId = (url) => {
	var matches = /\/([\w-_]{15,})\/(.*?gid=(\d+))?/.exec(url);
	if (matches == null) {
		return false;
	} else {
		return matches[1];
	}
};

/** Verify google sheet URL is valid or not */
export const verifySheet = async (url, token) => {
	return new Promise(async function (resolve, reject) {
		try {
			var spreadSheetId = getSpreadSheetId(url);

			if (!spreadSheetId) {
				resolve(false);
			} else {
				const config = {
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token}`,
					},
				};
				const { data } = await api.post(
					'/api/helper/verify-sheet',
					{
						spreadsheetId: spreadSheetId,
					},
					config
				);

				if (!data.success) {
					resolve(false);
				} else {
					let spreadsheetId = data.body.sheetId;
					let spreadsheetTitle = data.body.sheetName;
					resolve({
						spreadsheetId,
						spreadsheetTitle,
					});
				}
			}
		} catch (error) {
			resolve(false);
		}
	});
};

export const downloadGroupmMembersCsv = async (groupId, groupName, userInfo) => {
	let allLeads = [];
	try {
		let totalPage = 1;
		const getLeads = async (page) => {
			const config = {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${userInfo.gmBackendToken}`,
				},
			};
			const url = `/api/leads?page=${page}&gid=${groupId}`;
			const { data } = await api.get(url, config);
			return data;
		};
		const firstPageResult = await getLeads(1);
		if (firstPageResult?.success === true && firstPageResult?.body?.leads[0]?.data) {
			allLeads = allLeads.concat(
				firstPageResult?.body?.leads[0]?.data || []
			);
			if (firstPageResult?.body?.leads[0]?.metadata[0]?.total > 0) {
				totalPage =
					firstPageResult?.body?.leads[0]?.metadata[0]?.total %
						firstPageResult?.body?.leads[0]?.metadata[0]?.limit ===
						0
						? firstPageResult?.body?.leads[0]?.metadata[0]?.total /
						firstPageResult?.body?.leads[0]?.metadata[0]?.limit
						: parseInt(
							firstPageResult?.body?.leads[0]?.metadata[0]?.total /
							firstPageResult?.body?.leads[0]?.metadata[0]?.limit
						) + 1;
			}
		}
		for (let i = 2; i <= parseInt(totalPage || 1); i++) {
			const res = await getLeads(i);
			// console.log("res", res)
			if (res?.success === true && res?.body?.leads[0]?.data) {
				allLeads = allLeads.concat(
					res?.body?.leads[0]?.data || []
				);
			}
		}
	} catch (error) {
		const message =
			error.response && error.response.data.error
				? error.response.data.error
				: error.message;

		if (message === "NotAuthorized") {
			toast.error("Please login from extension and the reload this page");
			localStorage.removeItem("_gm_usr");
			window.location.reload();
		} else if (error.response.status === 401) {
			toast.error("Autorization failed, please re-login to the extension");
		} else {
			toast.error(message);
		}
	}


	if (allLeads?.length === 0) {
		toast.warning('No Data available for download.');
		return true
	}
	const cleanString = (val) => {
		let value = val?.replace(/[\n\t\s]+/gi, " ");
		if (value) {
			value = value.replace(/#/g, '')
		}
		if (value?.includes(',')) {
			value = `"${value}"`;
		}
		return value;
	}

	const allData = allLeads.map(item => ({
		groupName: cleanString(item?.group?.groupName),
		groupID: cleanString(item?.group?.groupId),
		userID: item?.fbuser?.userID,
		userName: cleanString(item?.fbuser?.userName),
		firstName: cleanString(item?.fbuser?.firstName),
		lastName: cleanString(item?.fbuser?.lastName),
		requestDate: item.requestDate,
		joinedDate: item?.fbuser?.joinedDate,
		noOfMutualFriends: item?.noOfMutualFriends,
		noOfTotalFriends: item?.noOfTotalFriends,
		noOfFriendsInGroup: item?.noOfFriendsInGroup,
		noOfCommonGroups: item?.noOfCommonGroups,
		noOfOtherGroups: item?.noOfOtherGroups,
		noOfTotalGroups: cleanString(item?.noOfTotalGroups),
		extraInformation: cleanString(item?.extraInformation) || "N/A",
		gender: item?.fbuser?.gender,
		country: item?.fbuser?.country,
		tiers: cleanString(item?.fbuser?.tiers),
		dateAdded: item?.dateAdded,
		status: item?.status,
		question1: cleanString(item?.question1),
		answer1: cleanString(item?.answer1),
		question2: cleanString(item?.question2),
		answer2: cleanString(item?.answer2),
		question3: cleanString(item?.question3),
		answer3: cleanString(item?.answer3),
	})
	)
	try {
		// let sheetData = Object.values(testDataForSheets).join(',');
		const rows = allData.map((obj) => Object.values(obj).join(",")).join("\n");
		let tableHead;
		tableHead =
			'Group Name, Group ID, User ID, Username, First Name, Last Name, Request Date, Joined Facebook On, No of Mutual Friends, No of Total Friends, No of Friends In Group, No of Common Groups, No of Other Groups, No of Total Groups, Extra Information, Gender, Country, Tiers, Date Added, Status, Q1, A1, Q2, A2, Q3, A3\n';

		let csvContent = 'data:text/csv;charset=utf-8,' + tableHead + rows;
		let encodedUri = encodeURI(csvContent);
		// console.log("encodedUri", encodedUri)

		let link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		// console.log("link", link)

		link.setAttribute('download', `${groupName || "Group"}-${new Date().getTime()}.csv`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		toast.success(`${groupName || "Group"} CSV has successfully downloaded`);
	} catch (error) {
		toast.error('Something went wrong ! Please try again');
	}
	return true
};
